import { object, string, nativeEnum, array, any } from 'zod';

import { makeZodValidate as makeValidate } from '@occc/ui-forms';
import { IS_REQUIRED, IS_VALID } from '@occc-app/lib/constants/validationMessages';
import { Retailer_Network_User_Role } from '@occc/graphql';
import { validatePhoneNumber } from '@occc/utils-phone-number';

export const createAndAssociateNewUserWithLocationGroups = object({
  firstName: string({ required_error: IS_REQUIRED }),
  lastName: string({ required_error: IS_REQUIRED }),
  phoneNumber: string().refine(validatePhoneNumber, { message: IS_VALID }).optional(),
  email: string({ required_error: IS_REQUIRED }).email(),
  userRole: nativeEnum(Retailer_Network_User_Role, { required_error: IS_REQUIRED }),
  locationGroups: array(any()).min(1, 'At least one location group must be selected'),
});

export const validateCreateAndAssociateNewUserWithLocations = makeValidate(
  createAndAssociateNewUserWithLocationGroups,
);
